import './lightbox.scss';

import {ComponentChild, FunctionalComponent, h} from "preact";
// https://static.querlo.com/images/fa-icons/duotone/mailbox.svg
export const Lightbox: FunctionalComponent<{ children: ComponentChild; lightboxCallback: (lightboxContent: ComponentChild) => void }> =
    ({
         children,
         lightboxCallback
     }) => {
        return <div id="lightbox" class="animated fadeIn screenShareRemoveMe">
          <div class="childrenWrp">
            <button className="close" onClick={() => lightboxCallback(null)}>
              <img src="https://staging.querlo.com/images/close.png" alt="close dialog" />
            </button>
            {children}
          </div>
        </div>
    };
